module.exports = __webpack_public_path__ + "static/media/alvap-img.fa36a5c0.png";